module.exports = __webpack_public_path__ + "static/media/multiple-choice-timed-cards.5ed9aebb.svg";